import { useEffect, useState } from 'react';
import { useQuery } from '@apollo/client/react';
import { useDebouncedCallback } from 'use-debounce';
import { SearchEntityTypeEnum } from 'shared/domains/apollo/generated/types';
import { ProjectSearchDocument } from './query.gql';
import { normalizeSearchResult } from './utils';
export const useProjectSearch = (selectedIds) => {
    var _a, _b, _c, _d, _e, _f;
    const [searchString, setSearchString] = useState('');
    const { data, previousData, error, loading } = useQuery(ProjectSearchDocument, {
        variables: {
            query: searchString,
            limit: 20,
            modifiers: { isFuzzy: false },
            where: { entityType: { in: [SearchEntityTypeEnum.Project] } },
            selectedIds,
        },
    });
    const currentSearchResult = (_b = (((_a = data === null || data === void 0 ? void 0 : data.search) === null || _a === void 0 ? void 0 : _a.results) || [])) === null || _b === void 0 ? void 0 : _b.map(normalizeSearchResult);
    const currentProjectResult = (_c = ((data === null || data === void 0 ? void 0 : data.selectedProjects) || [])) === null || _c === void 0 ? void 0 : _c.map(normalizeSearchResult);
    const previousSearchResult = (_e = (((_d = previousData === null || previousData === void 0 ? void 0 : previousData.search) === null || _d === void 0 ? void 0 : _d.results) || [])) === null || _e === void 0 ? void 0 : _e.map(normalizeSearchResult);
    const previousProjectResult = (_f = ((previousData === null || previousData === void 0 ? void 0 : previousData.selectedProjects) || [])) === null || _f === void 0 ? void 0 : _f.map(normalizeSearchResult);
    const currentData = [...currentSearchResult, ...currentProjectResult];
    const prevData = [...previousSearchResult, ...previousProjectResult];
    const dataToUse = loading ? prevData : currentData;
    const searchForProjects = useDebouncedCallback(() => {
        setSearchString(searchString);
    }, 250);
    const clearSearch = () => setSearchString('');
    useEffect(() => {
        if (searchString.length > 0) {
            searchForProjects();
        }
    }, [searchString, searchForProjects]);
    return {
        error,
        loading,
        search: searchString,
        setSearch: setSearchString,
        clearSearch,
        searchResults: dataToUse,
    };
};
